import Banner from './Banner';
import Body from './Body';
import Container from './Container';
import Header from './Header';
import Main from './Main';
import MainContent from './MainContent';
import Toolbar from './Toolbar';
import Breadcrumbs from './Breadcrumbs';
import Navigation from './Navigation';
import * as _LeftRail from './LeftRail';
import * as _RightRail from './RightRail';

const { default: LeftRail, ...lrRest } = _LeftRail;
const { default: RightRail, ...rrRest } = _RightRail;

const ids = {
  /**
   * @note the window doesn't send a scroll event, thus we'll need to watch the main-content for scrolling
   *
   * @todo we should think of a way to either bubble scroll events on the main-content to the window or
   *      find a way to re-arrange the css such that the window is the one that scrolls (without resorting to
   *      an overuse of position elements **possibly**)
   */
  MAIN_CONTENT_ID: 'layout-main-content',
};

const Layout = {
  ...ids,
  Banner,
  Body,
  Breadcrumbs,
  Container,
  Header,
  Main,
  MainContent,
  Toolbar,
  Navigation,
  LeftRail,
  ...lrRest,
  RightRail,
  ...rrRest,
};

export default Layout;
